import 'alpinejs';

window.showShareableUrl = function () {
    var copyText = document.getElementById("encodedShareableLink");
    copyText.select();
    copyText.setSelectionRange(0, 99999)
    if (copyText.value.length > 5) {
        window.prompt("Copy the shareable URL below. Expires in 30 days.", copyText.value);
    } else {
        alert('Please perform a search before attempting to get a shareable URL.');
    }
}

window.fields = function () {
    return {
        isEmpty(value) {
            let operation = String(value.op ?? '');
            let val = String(value.val ?? value ?? '');

            if (operation.trim().length > 0) {
                return false;
            } else {
                return val.trim().length === 0;
            }
        },
    }
};

window.panes = function () {
    return {
        showProductsPane: true,
        showNetworksPane: false,
        showMerchantsPane: false,
        showJsonPane: false,
        showAboutPane: false,

        openProductsPane() {
            this.hidePanes();
            this.showProductsPane = true;
        },
        openNetworksPane() {
            this.hidePanes();
            this.showNetworksPane = true;
        },
        openMerchantsPane() {
            this.hidePanes();
            this.showMerchantsPane = true;
        },
        openJsonPane() {
            this.hidePanes();
            this.showJsonPane = true;
        },
        openAboutPane() {
            this.hidePanes();
            this.showAboutPane = true;
        },
        hidePanes() {
            this.showProductsPane = false;
            this.showNetworksPane = false;
            this.showMerchantsPane = false;
            this.showJsonPane = false;
            this.showAboutPane = false;
        },
    }
};


// window.scratchpad = function () {
//     return {
//         showProductsPane: true,
//         showNetworksPane: false,
//         showMerchantsPane: false,
//         showJsonPane: false,
//
//         openProductsPane() {
//             this.hidePanes();
//             this.showProductsPane = true;
//         },
//         openNetworksPane() {
//             this.hidePanes();
//             this.showNetworksPane = true;
//         },
//         openMerchantsPane() {
//             this.hidePanes();
//             this.showMerchantsPane = true;
//         },
//         openJsonPane() {
//             this.hidePanes();
//             this.showJsonPane = true;
//         },
//         productsPaneIsOpen() {
//             return this.showProductsPane === true
//         },
//         networksPaneIsOpen() {
//             return this.showNetworksPane === true
//         },
//         merchantsPaneIsOpen() {
//             return this.showMerchantsPane === true
//         },
//         jsonPaneIsOpen() {
//             return this.showJsonPane === true
//         },
//         hidePanes() {
//             this.showProductsPane = false;
//             this.showNetworksPane = false;
//             this.showMerchantsPane = false;
//             this.showJsonPane = false;
//         },
//     }
// };

// window.searchForm = function () {
//
//     return {
//         // selectedFields: [],
//
//         toggleFieldSelection(field) {
//             if (this.fieldSelected(field)) {
//                 this.removeField(field);
//             } else {
//                 this.addField(field);
//             }
//         },
//
//         fieldSelected(field) {
//             return this.selectedFields.includes(field);
//         },
//
//         addField(field) {
//             this.selectedFields.push(field);
//         },
//
//         removeField(field) {
//             let index = this.selectedFields.indexOf(field);
//             this.selectedFields.splice(index, 1);
//         },
//
//     }
// };

// window.fields = function () {
//     return {
//         anyFieldVisible: true,
//         nameFieldVisible: false,
//         descriptionFieldVisible: false,
//         brandFieldVisible: false,
//         colorFieldVisible: false,
//         sizeFieldVisible: false,
//         categoryFieldVisible: false,
//         salediscountFieldVisible: false,
//         finalpriceFieldVisible: false,
//         idsFieldVisible: false,
//     }
// };


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
